$(function () {
    bindArticleTeaserRegionTagEvent();
    bindArticleTagEvent();
});

function bindArticleTeaserRegionTagEvent() {
    let $region = $("a.article-hero__region");
    let url = window.location.pathname.split("/");
    let pos = url.length - 2;
    url.splice(pos, 2);
    let target = url.join("/");

    $(".camc-article-brief .card-section.category a").each(function () {
        let regionTag = $(this).text();
        $(this).attr("href", `${target}?r=${regionTag}`);
    });
    $region.attr("href", `${target}?r=${$region.text()}`);
}

function bindArticleTagEvent() {}
